import React, { useState, useEffect } from 'react';
import '../../entrydoor.css';

const Discount = ({ value, onChange, label = 'Discount:', disabled  = false}) => {
    const [selectedDiscount, setSelectedDiscount] = useState(value || "0");

    // Sync state with value prop if it changes
    useEffect(() => {
        setSelectedDiscount(value || "0");
    }, [value]);

    const handleDiscountChange = (e) => {
        setSelectedDiscount(e.target.value);
        onChange(e.target.value);
    };

    return (
        <div className="a-container">
            <label htmlFor="Discount" disabled={disabled} >{label}</label>
            <input
                disabled={disabled}
                type="number"
                id="Discount"
                value={selectedDiscount}
                onChange={handleDiscountChange}
                min="0"
            />
        </div>
    );
};

export default Discount;
